<template>
  <div>
    <h6>Thông tin phiếu</h6>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label"> Mã phiếu </label>
      <div class="col-sm-9 p-m-5">
        <p>{{ item && item.code ? item.code : '' }}</p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label"> Loại ưu đãi </label>
      <div class="col-sm-9 p-m-5">
        <p>{{ item && item.typeOffer ? joinArrayData(item.typeOffer, optionType) : '' }}</p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Tên MC </label>
      <div class="col-sm-9 p-m-5">
        <p>{{ merchant && merchant.merchantName ? merchant.merchantName : '' }}</p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Email MC </label>
      <div class="col-sm-9 p-m-5">
        <p>{{ merchant && merchant.email ? merchant.email : '' }}</p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Trạng thái </label>
      <div class="col-sm-9 p-m-5">
        <span
          class="badge"
          :class="item && item.status ? getColor(item.status, optionColorStatus) : ''"
          >{{ item && item.status ? joinArrayData(item.status, optionStatus) : '' }}</span
        >
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Người tạo </label>
      <div class="col-sm-9 p-m-5">
        <p>{{ item && item.createByEmail ? item.createByEmail : '' }}</p>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Ngày tạo </label>
      <div class="col-sm-9 p-m-5">
        <p v-if="item && item.createAt">{{ item.createAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    watch: {},
    data() {
      return {
        optionType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_KEY_ONUS', text: 'Merchant key + onus' },
        ],
        optionColorStatus: {
          NEW: 'success',
          AWAITING_MANAGER_APPROVAL: 'info',
          MANAGER_REJECTED: 'danger',
          MANAGER_REQUESTED_ADDITIONAL: 'danger',
          AWAITING_OPERATION_APPROVAL: 'info',
          OPERATION_REQUESTED_EDIT: 'danger',
          OPERATION_APPROVED: 'primary',
          CANCELED: 'danger',
        },
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'AWAITING_MANAGER_APPROVAL', text: 'Chờ GĐV duyệt' },
          { id: 'MANAGER_REJECTED', text: 'Từ chối' },
          { id: 'MANAGER_REQUESTED_ADDITIONAL', text: 'GĐV YC Bổ sung' },
          { id: 'AWAITING_OPERATION_APPROVAL', text: 'Chờ VH duyệt' },
          { id: 'OPERATION_REQUESTED_EDIT', text: 'VH yêu cầu bổ sung' },
          { id: 'OPERATION_APPROVED', text: 'VH đã duyệt' },
          { id: 'CANCELED', text: 'Đã huỷ' },
        ],
        showDisplay: false,
        item: {},
        merchant: {},
      }
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
    },
    methods: {
      show(item, merchant) {
        this.item = item
        this.merchant = merchant
      },
    },
  }
</script>
<style scoped>
  .success {
    color: #fff;
    background-color: #28a745;
  }

  .info {
    color: #fff;
    background-color: #117a8b;
  }

  .danger {
    color: #fff;
    background-color: #dc3545;
  }

  .primary {
    color: #fff;
    background-color: #007bff;
  }
</style>
